enum WorkspaceProjectMilestoneType {
  single = 'single',
  recurring = 'recurring',
  multiItem = 'multi_item',
}

export default WorkspaceProjectMilestoneType
